import React, { useRef, useState, useEffect  } from 'react';
import { Link } from "react-router-dom";
import Select from "react-select";
import { Button } from "react-bootstrap";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import apf_logo from '../../../images/auth/apf_logo_bg.png';
import apf_small_logo from '../../../images/auth/apf_small_logo.png';
import axios from 'axios';
 import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GeneralSettings = () => {
    // const [formData, setFormData] = useState({});
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [country, setCountry] = useState([]);
    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    // const [formErrors, setFormErrors] = useState({});
    const [logoUrl, setLogoUrl] = useState(null); 
    const [faviconUrl, setFaviconUrl] = useState(null);
    // const [imgUrl, setLimgUrl] = useState('apf_logo.png');
    const [formData, setFormData] = useState({
        title: '',
        website_url: '',
        contact_person_name: '', 
        contact_person_email_id: '', 
        contact_person_mobile_no: '', 
        whatsapp_no: '', 
        pincode: '', 
        cgst: '', 
        sgst: '', 
        gst: '', 
        cin: '',
        city: '',
        state: '',
        country: '',
        date_format: '',
        fav_icon: '',
        logo: '' ,
        refund_deducted: '',
        max_refund_eligible: '',
        max_refund_days: '',
        max_postpone_days: '',
});

    useEffect(() => {
        axios.get(`${baseURL}/generalSetting/1`)
          .then(response => {
            if (response.data && response.data.data) {
              const data = response.data.data;
              console.log('API Response:', data);
              setFormData(data);
    
              setSelectedCountry({
                value: data.country,
                label: data.country_name
              });
    
              setSelectedState({
                value: data.state,
                label: data.state_name
              });
    
              setSelectedCity({
                value: data.city,
                label: data.name
              });

              const dateFormatOption = options_date_format.find(
            (option) => option.value === data.date_format
            );
            if (dateFormatOption) {
            setSelectedDateFormat(dateFormatOption);
            }
            // Set logo and favicon URLs from API
            setLogoUrl(data.logo || null);
            setFaviconUrl(data.fav_icon || null);
            }else {
                console.error("Unexpected API response structure:", response);
            }
            })
          .catch(error => {
            console.error("Failed to fetch general settings:", error);
          });
    }, []);
    
      useEffect(() => {
        axios.get(`${baseURL}/country`)
          .then(res => {
            const formatted = res.data.map(country => ({
              value: country.id,
              label: country.name
            }));
            setCountry(formatted);
          })
          .catch(err => console.error("Error loading country", err));
      }, []);

      useEffect(() => {
        if (selectedCountry) {
          axios.get(`${baseURL}/state?country_id=${selectedCountry.value}`)
            .then(res => {
              const formatted = res.data.data.map(state => ({
                value: state.id,
                label: state.state_name
              }));
              setState(formatted);
            //   setSelectedState(null); // Reset state when country changes
            })
            .catch(err => console.error("Error loading state", err));
        }
      }, [selectedCountry]);

      useEffect(() => {
        if (selectedState) {
          axios.get(`${baseURL}/city?state_id=${selectedState.value}`)
            .then(res => {
              const formatted = res.data.data.map(city => ({
                value: city.sid,
                label: city.name
              }));
              setCity(formatted);
            //   setSelectedCity(null); // Reset city when state changes
            })
            .catch(err => console.error("Error loading cities", err));
        }
      }, [selectedState]);

    useEffect(() => {
    if (faviconUrl) {
        const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.href = faviconUrl;
        document.getElementsByTagName('head')[0].appendChild(link);
    }
}, [faviconUrl]);

    

    const [formErrors, setFormErrors] = useState({
        title: '',
        website_url: '',
        ontact_person_name: '', 
        contact_person_email_id : '', 
        contact_person_mobile_no: '', 
        whatsapp_no: '', 
        pincode: '', 
        cgst: '', 
        sgst: '', 
        gst: '', 
        cin:'',
        refund_deducted: '',
        max_refund_eligible: '',
        max_refund_days: '',
        max_postpone_days: '',
        });
    
    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    };
    

    const validateForm = () => {
        const { 
            title, 
            website_url, 
            contact_person_name, 
            contact_person_email_id, 
            contact_person_mobile_no, 
            whatsapp_no, 
            pincode, 
            cgst, 
            sgst, 
            gst, 
            cin,
            refund_deducted,
            max_refund_eligible,
            max_refund_days,
            max_postpone_days,
            
        } = formData;
        let errors = {};
        

        // Required fields
        if (!title) errors.title = "This Field is required.";
        if (!website_url) errors.website_url = "This Field is required.";
        if (!contact_person_name) errors.contact_person_name = "This Field is required.";
        if (!contact_person_email_id) errors.contact_person_email_id = "This Field is required.";
        if (!contact_person_mobile_no) errors.contact_person_mobile_no = "This Field is required.";
        if (!whatsapp_no) errors.whatsapp_no = "This Field is required.";
        if (!pincode) errors.pincode = "This Field is required.";
        if (!cin) errors.cin = "This Field is required.";
        if (!selectedCountry) errors.country = "This Field is required.";
        if (!selectedState) errors.state = "This Field is required.";
        if (!selectedCity) errors.city = "This Field is required.";
        if (!selectedDateFormat || selectedDateFormat.value === "0") {
                errors.date_format = "This Field is required.";
            }


        // Field-specific validations
        if (pincode && !/^\d{6}$/.test(pincode)) {
            errors.pincode = "Pincode must be 6 digits.";
        }
        if (contact_person_mobile_no && !/^\d+$/.test(contact_person_mobile_no)) {
            errors.contact_person_mobile_no = "Mobile number must be numeric.";
        }
        if (whatsapp_no && !/^\d+$/.test(whatsapp_no)) {
            errors.whatsapp_no = "Whatsapp number must be numeric.";
        }
        if (cgst && (parseFloat(cgst) < 0 || parseFloat(cgst) > 100)) {
            errors.cgst = "CGST must be between 0 and 100.";
        }
        if (sgst && (parseFloat(sgst) < 0 || parseFloat(sgst) > 100)) {
            errors.sgst = "SGST must be between 0 and 100.";
        }
        if (gst && (parseFloat(gst) < 0 || parseFloat(gst) > 100)) {
            errors.gst = "GST must be between 0 and 100.";
        }
        if (contact_person_email_id && !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(contact_person_email_id)) {
            errors.contact_person_email_id = "Please enter a valid email.";
        }
        if (refund_deducted === undefined || refund_deducted === "") {
            errors.refund_deducted = "Refund deducted amount is required.";
        } else if (!/^\d+(\.\d+)?$/.test(refund_deducted)) {
            errors.refund_deducted = "Refund deducted amount must be numeric.";
        }else if (parseFloat(refund_deducted) < 0 || parseFloat(refund_deducted) > 100) {
            errors.refund_deducted = "Min Advance must be between 0 and 100.";
        }

        if (max_refund_eligible === undefined || max_refund_eligible === "") {
            errors.max_refund_eligible = "Max refund eligible is required.";
        } else if (!/^\d+(\.\d+)?$/.test(max_refund_eligible)) {
            errors.max_refund_eligible = "Max refund eligible must be numeric.";
        } else if (parseFloat(max_refund_eligible) < 0 || parseFloat(max_refund_eligible) > 100) {
            errors.max_refund_eligible = "Max refund eligible must be between 0 and 100.";
        }

        if (max_refund_days === undefined || max_refund_days === "") {
            errors.max_refund_days = "Max refund days is required.";
        } else if (!/^\d+$/.test(max_refund_days)) {
            errors.max_refund_days = "Max refund days must be a number.";
        }

        if (max_postpone_days === undefined || max_postpone_days === "") {
            errors.max_postpone_days = "Order cancel/postpone days is required.";
        } else if (!/^\d+$/.test(max_postpone_days)) {
            errors.max_postpone_days = "Order cancel/postpone days must be a number.";
        }


        setFormErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const uploadFile = async (file) => {
        if (!file) return null;
        const formData = new FormData();
        formData.append('logo', file);
      
        try {
          const response = await axios.post(`${baseURL}/generalSetting/1`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              // Uncomment if authentication is required
              // 'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          });
          return response.data.fileUrl;  // Assuming the response has a file URL or file ID
        } catch (error) {
          console.error('Error uploading file:', error);
          return null;
        }
      };

    const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
        const data = new FormData();

        // Append non-file fields
        data.append('title', formData.title || '');
        data.append('website_url', formData.website_url || '');
        data.append('contact_person_name', formData.contact_person_name || '');
        data.append('contact_person_email_id', formData.contact_person_email_id || '');
        data.append('contact_person_mobile_no', formData.contact_person_mobile_no || '');
        data.append('whatsapp_no', formData.whatsapp_no || '');
        data.append('address', formData.address || '');
        data.append('pincode', formData.pincode || '');
        data.append('cgst', formData.cgst || 0);
        data.append('sgst', formData.sgst || 0);
        data.append('gst', formData.gst || 0);
        data.append('cin', formData.cin || '');
        data.append('country', selectedCountry?.value || '');
        data.append('state', selectedState?.value || '');
        data.append('city', selectedCity?.value || '');
        data.append('date_format', selectedDateFormat?.value || '');
        data.append('status', formData.status || 0);
        data.append('refund_deducted', formData.refund_deducted || 0);
        data.append('max_refund_eligible', formData.max_refund_eligible || 0);
        data.append('max_refund_days', formData.max_refund_days || 0);
        data.append('max_postpone_days', formData.max_postpone_days || 0);

        
        if (file) {
            data.append('logo', file);
        } else if (formData.logo === '') {
            data.append('remove_logo', 'true'); // Signal backend to remove logo
        }

        // Append favicon file only if it exists, otherwise signal removal
        if (fileicon) {
            data.append('fav_icon', fileicon);
        } else if (formData.fav_icon === '') {
            data.append('remove_fav_icon', 'true'); // Signal backend to remove favicon
        }

        try {
        const response = await axios.post(`${baseURL}/generalSetting/1`, data, {
            headers: {
            'Content-Type': 'multipart/form-data',
            },
        });

        console.log('Backend response:', response.data);
        if (response.data && response.data.data) {
                const updatedData = response.data.data;
                setFormData(updatedData); // Update formData with new data
                setLogoUrl(updatedData.logo || null); // Update logoUrl
                setFaviconUrl(updatedData.fav_icon || null); // Update faviconUrl
                setFile(null); // Clear file state after successful submission
                setFileicon(null); // Clear fileicon state
                if (imageInputRef.current) imageInputRef.current.value = ''; // Clear logo input
                if (imageInputReficon.current) imageInputReficon.current.value = ''; // Clear favicon input
                toast.success('Settings Updated Successfully');
            }
        } catch (err) {
            console.error('Error updating settings:', err);
            toast.error('Unexpected Error Occured');
        }
    }
    };

    // Icon
    const [file, setFile] = useState(null)
    const imageInputRef = useRef(null);
    const fileHandler = (e) => {
        const selectedFile = e.target.files[0];
        console.log(selectedFile);
        if (selectedFile) {
            setFile(selectedFile);
            setFormData(prev => ({ ...prev, ['logo']: selectedFile }));
            setLogoUrl(URL.createObjectURL(selectedFile));
        }
        console.log(formData);
    }

    const RemoveImage = () => {
    setFile(null); // Clear the file state
    setFormData(prev => ({ ...prev, logo: '' })); // Clear the logo in formData
    setLogoUrl(null); // Reset logoUrl to null or a default image
    if (imageInputRef.current) {
        imageInputRef.current.value = ''; // Clear the input value
    }
};
    // End Icon
    // Fav Icon
    const [fileicon, setFileicon] = React.useState(null)
    const imageInputReficon = useRef(null);
    const fileHandlericon = (e) => {
        const selectedFileIcon = e.target.files[0];
        if (selectedFileIcon) {
            setFileicon(selectedFileIcon);
            setFormData(prev => ({ ...prev, ['fav_icon']: selectedFileIcon }));
            setFaviconUrl(URL.createObjectURL(selectedFileIcon));
        }
    }

    const RemoveImageicon = () => {
    setFileicon(null); // Clear the fileicon state
    setFormData(prev => ({ ...prev, fav_icon: '' })); // Clear the fav_icon in formData
    setFaviconUrl(null); // Reset faviconUrl to null or a default
    if (imageInputReficon.current) {
        imageInputReficon.current.value = ''; // Clear the input value
    }
};
    // End fav icon
    const [selectedDateFormat, setSelectedDateFormat] = useState(null);
    const options_date_format = [
        { value: "0", label: "Select Date Format" },
        { value: "d-m-Y", label: "dd-mm-yyyy", isFixed: true },
        { value: "m-d-Y", label: "mm-dd-yyyy" },
        { value: "Y-m-d", label: "yyyy-mm-dd" },
    ];

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#ea1d25' }}>General Settings</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">General Settings</li>
                    </ol>
                </div>
            </div>
            <form onSubmit={handleSubmit}>
            <div className='row'>
                <div className="col-lg-6 mb-4">
                    <div className="row">
                        <div className="col-lg-3">
                            <label className="text-black font-w500 fs-6">Logo<span className="required">*</span></label>
                        </div>
                        <div className="col-lg-9">
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative">
                                    <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                        <img
                                            id="saveImageFile"
                                            // src={apf_logo}
                                            src={file ? URL.createObjectURL(file) : logoUrl || apf_logo}
                                            alt={file ? file.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                            style={{ display: 'none' }}
                                            onChange={fileHandler}
                                            ref={imageInputRef}
                                        />
                                        <div className="mt-2 d-flex align-items-center justify-content-center gap-3">
                                            <Button
                                                className="btn-xs mb-2"
                                                variant="success"
                                                onClick={() => imageInputRef.current.click()}
                                            >
                                                <span>
                                                    <i className="fa fa-upload color-success fs-4" />
                                                </span>
                                            </Button>
                                            <Button
                                                  className="btn-xs mb-2"
                                                  variant="danger"
                                                  onClick={RemoveImage}
                                              >
                                                  <span>
                                                      <i className="fa fa-close color-danger fs-4" />
                                                  </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 mb-4">
                    <div className="row">
                        <div className="col-lg-3">
                            <label className="text-black font-w500 fs-6">Fav Icon<span className="required">*</span></label>
                        </div>
                        <div className="col-lg-9">
                            <div className="avatar-upload d-flex align-items-center">
                                <div className="change position-relative">
                                    <div className="avatar-preview h-125px w-125px border" style={{ borderRadius: '10px' }}>
                                        <img
                                            id="saveImageFile_Icon"
                                            src={fileicon ? URL.createObjectURL(fileicon) : faviconUrl || apf_small_logo}
                                            alt={fileicon ? fileicon.name : 'Default Avatar'}
                                            className="p-1 h-125px w-125px"
                                        />
                                    </div>
                                    <div className="change-btn">
                                        <input
                                            type="file"
                                            id="imageUpload"
                                            accept=".png, .jpg, .jpeg"
                                            style={{ display: 'none' }}
                                            onChange={fileHandlericon}
                                            ref={imageInputReficon}
                                        />
                                        <div className="mt-2 d-flex align-items-center justify-content-center gap-3">
                                            <Button
                                                 className="btn-xs mb-2"
                                                variant="success"
                                                onClick={() => imageInputReficon.current.click()}
                                            >
                                                <span>
                                                    <i className="fa fa-upload color-success fs-4" />
                                                </span>
                                            </Button>
                                            <Button
                                                className="btn-xs mb-2"
                                                variant="danger"
                                                onClick={RemoveImageicon}
                                            >
                                                <span>
                                                    <i className="fa fa-close color-danger fs-4" />
                                                </span>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Title<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Title" value={formData.title || ""}
                onChange={handleChange} name="title"/>
                {formErrors.title && <div className="text-danger mt-1">{formErrors.title}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Website URL<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Website URL" value={formData.website_url || ""}
                onChange={handleChange} name="website_url"/>
                {formErrors.website_url && <div className="text-danger mt-1">{formErrors.website_url}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Contact Person Name<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Contact Person Name" value={formData.contact_person_name || ""}
                onChange={handleChange} name="contact_person_name"/>
                {formErrors.contact_person_name && <div className="text-danger mt-1">{formErrors.contact_person_name}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Contact Person Email ID<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Contact Person Email ID" value={formData.contact_person_email_id || ""}
                onChange={handleChange} name="contact_person_email_id"/>
                {formErrors.contact_person_email_id && <div className="text-danger mt-1">{formErrors.contact_person_email_id}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Contact Person Mobile No<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Contact Person Mobile No" value={formData.contact_person_mobile_no || ""}
                onChange={handleChange} name="contact_person_mobile_no"/>
                {formErrors.contact_person_mobile_no && <div className="text-danger mt-1">{formErrors.contact_person_mobile_no}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Whatsapp No<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Whatsapp No"  value={formData.whatsapp_no || ""}
                onChange={handleChange} name="whatsapp_no"/>
                {formErrors.whatsapp_no && <div className="text-danger mt-1">{formErrors.whatsapp_no}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Date Format <span className="required">*</span></label>
                    <Select
                    value={selectedDateFormat}
                    onChange={setSelectedDateFormat}
                    options={options_date_format}
                    placeholder="Select Date Format"
                    />
                    {formErrors.date_format && <div className="text-danger mt-1">{formErrors.date_format}</div>}
                </div>
                <div className="col-lg-8 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Address</label>
                    <textarea rows={4} className="form-control" name="address" placeholder="Address" value={formData.address || ""}
                onChange={handleChange} />
                 {formErrors.address && <div className="text-danger mt-1">{formErrors.address}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Country<span className="required">*</span></label>
                    <Select
                        value={selectedCountry}
                        onChange={(selected) => {
                          setSelectedCountry(selected);    // Set new country
                          setSelectedState(null);         // Reset state
                          setSelectedCity(null);          // Reset city
                        }}
                        options={country}
                        placeholder="Select Country"
                    />
                    {formErrors.country && <div className="text-danger mt-1">{formErrors.country}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">State<span className="required">*</span></label>
                    <Select
                        value={selectedState}
                        onChange={(selected) => {
                          setSelectedState(selected);     // Set new state
                          setSelectedCity(null);          // Reset city
                        }}
                        options={state}
                        placeholder="Select State"
                        isDisabled={!selectedCountry}
                    />
                    {formErrors.state && <div className="text-danger mt-1">{formErrors.state}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">City<span className="required">*</span></label>
                    <Select
                        value={selectedCity}
                        onChange={setSelectedCity}
                        options={city}
                        placeholder="Select City"
                        isDisabled={!selectedState}
                    />
                    {formErrors.city && <div className="text-danger mt-1">{formErrors.city}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">Pincode<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter Pincode"  value={formData.pincode || ""}
                onChange={handleChange} name="pincode"/>
                {formErrors.pincode && <div className="text-danger mt-1">{formErrors.pincode}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">CGST (%)</label>
                    <input type="text" className="form-control" placeholder="Enter CGST"  value={formData.cgst || ""}
                onChange={handleChange}  name="cgst"/>
                {formErrors.cgst && <div className="text-danger mt-1">{formErrors.cgst}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">SGST (%)</label>
                    <input type="text" className="form-control" placeholder="Enter SGST"  value={formData.sgst || ""}
                onChange={handleChange}  name="sgst"/>
                {formErrors.sgst && <div className="text-danger mt-1">{formErrors.sgst}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">GST (%)<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter GST"  value={formData.gst || ""}
                onChange={handleChange}  name="gst"/>
                {formErrors.gst && <div className="text-danger mt-1">{formErrors.gst}</div>}
                </div>
                <div className="col-lg-4 mb-4">
                    <label className="text-black font-w500 mb-0 fs-7">CIN<span className="required">*</span></label>
                    <input type="text" className="form-control" placeholder="Enter CIN"  value={formData.cin || ""}
                onChange={handleChange}  name="cin"/>
                 {formErrors.cin && <div className="text-danger mt-1">{formErrors.cin}</div>}
                </div>
                 <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 mb-0 fs-7">Min Advance Amount (in %)<span className="required">*</span></label>
                <input type="text" className="form-control" placeholder="Enter Min Advance Amount" value={formData.refund_deducted || ""} onChange={handleChange} name="refund_deducted" />
                {formErrors.refund_deducted && <div className="text-danger mt-1">{formErrors.refund_deducted}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 mb-0 fs-7">Max Refund Eligible In Total(in %)<span className="required">*</span></label>
                <input type="text" className="form-control" placeholder="Enter Max Refund Eligible" value={formData.max_refund_eligible || ""} onChange={handleChange} name="max_refund_eligible" />
                {formErrors.max_refund_eligible && <div className="text-danger mt-1">{formErrors.max_refund_eligible}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 mb-0 fs-7">Max Refund Days (Req. Date)<span className="required">*</span></label>
                <input type="text" className="form-control" placeholder="Enter Max Refund Days" value={formData.max_refund_days || ""} onChange={handleChange} name="max_refund_days" />
                {formErrors.max_refund_days && <div className="text-danger mt-1">{formErrors.max_refund_days}</div>}
                </div>

                <div className="col-lg-4 mb-4">
                <label className="text-black font-w500 mb-0 fs-7">Order Cancel/ Postpond Days (Req. Date)<span className="required">*</span></label>
                <input type="text" className="form-control" placeholder="Enter Order Cancel/ Postpond Days" value={formData.max_postpone_days || ""} onChange={handleChange} name="max_postpone_days" />
                {formErrors.max_postpone_days && <div className="text-danger mt-1">{formErrors.max_postpone_days}</div>}
                </div>       
            </div>
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                <Link to={"/dashboard"} className="btn btn-sm btn-secondary">Cancel</Link>
                <button type="submit" className="btn btn-sm btn-primary">Update</button>
            </div>
            </form>
        </>
    )


}
export default GeneralSettings; 